import styled from "styled-components";
import {textColor} from "@scriba/ui-lib";

const SeparationDiv = styled.div`
  border-bottom: 2px solid ${textColor('secondary')};
`;

export default SeparationDiv;